import { useEffect } from 'react';
import {
  getRating,
  getRatingItems,
  pharmacyActions,
  rating,
  ratingItems,
} from '@pharmaplan/common';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';

const useViewRating = (id: string) => {
  const dispatch = useAppDispatch();

  const ratingDetails = useAppSelector(rating);
  const ratingData = useAppSelector(ratingItems);

  useEffect(() => {
    dispatch(getRatingItems(id));
    dispatch(getRating(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ratingData,
    ratingDetails,
    successAction: pharmacyActions.rating,
    idProperty: 'pharmacistRatingItemId',
    itemProperty: 'pharmacistRatingItems',
    title: strings.pharmacistRating,
  };
};

export default useViewRating;
